module.exports = __webpack_public_path__ + "static/media/project2.aa30e78c.png";